// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader@6.11.0_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader@6.11.0_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RRT__container {
  position: relative;
}

/****************************/
/******** tab styles ********/
/****************************/
.RRT__tabs {
  display: flex;
  flex-wrap: wrap;
}

.RRT__accordion {
  flex-direction: column;
}

.RRT__tab {
  background: #eee;
  border-style: solid;
  border-color: #ddd;
  border-width: 1px 1px 1px 0;
  cursor: pointer;
  z-index: 1;
  white-space: nowrap;
  padding: 0.7em 1em;
}

.RRT__tab:focus {
  outline: 0;
  background-color: #e6e6e6;
}

.RRT__accordion .RRT__tab {
  border-left-width: 1px;
}

.RRT__tab--first {
  border-left-width: 1px;
}

.RRT__tab--selected {
  background: #fff;
  border-color: #ddd #ddd #fff;
}

.RRT__tab--selected:focus {
  background-color: #fff;
}

.RRT__tab--disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.RRT__tab:focus {
  z-index: 2;
}

.RRT__tab--selected .RRT__removable {
  position: relative;
}

.RRT__tab--selected .RRT__removable-text {
  margin-right: 10px;
}

.RRT__tab--selected .RRT__removable-icon {
  position: absolute;
  font-size: 18px;
  right: 0.5em;
  top: 0.2em;
}

/****************************/
/********* panel styles *****/
/****************************/
.RRT__panel {
  margin-top: -1px;
  padding: 1em;
  border: 1px solid #ddd;
}

.RRT__panel--hidden {
  display: none;
}

.RRT__accordion .RRT__panel {
  margin-top: 0;
}

/****************************/
/******* showmore control ***/
/****************************/
.RRT__showmore {
  background: #eee;
  border: 1px solid #ddd;
  cursor: pointer;
  z-index: 1;
  white-space: nowrap;
  margin-left: -1px;
  position: relative;
}

.RRT__showmore--selected {
  background: white;
  border-bottom: none;
}

.RRT__showmore-label {
  padding: 0.7em 1em;
  position: relative;
  bottom: -1px;
  z-index: 1;
}

.RRT__showmore-label--selected {
  background-color: #eee;
}

.RRT__showmore-list {
  position: absolute;
  right: -1px;
  top: 100%;
  display: none;
}

.RRT__showmore-list--opened {
  display: block;
}

/****************************/
/********** inkbar **********/
/****************************/
.RRT__inkbar-wrapper {
  width: 100%;
}

.RRT__inkbar {
  position: relative;
  bottom: 0;
  height: 2px;
  margin-top: -2px;
  background-color: deepskyblue;
  transition: left 800ms cubic-bezier(0.23, 1, 0.32, 1);
  z-index: 2;
}
`, "",{"version":3,"sources":["webpack://./node_modules/.pnpm/react-responsive-tabs@4.4.3_react-dom@17.0.2_react@17.0.2/node_modules/react-responsive-tabs/styles.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B,6BAA6B;AAC7B,6BAA6B;AAC7B;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,UAAU;EACV,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,UAAU;AACZ;;AAEA,6BAA6B;AAC7B,6BAA6B;AAC7B,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,6BAA6B;AAC7B,6BAA6B;AAC7B,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,UAAU;EACV,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA,6BAA6B;AAC7B,6BAA6B;AAC7B,6BAA6B;AAC7B;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,qDAAqD;EACrD,UAAU;AACZ","sourcesContent":[".RRT__container {\n  position: relative;\n}\n\n/****************************/\n/******** tab styles ********/\n/****************************/\n.RRT__tabs {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.RRT__accordion {\n  flex-direction: column;\n}\n\n.RRT__tab {\n  background: #eee;\n  border-style: solid;\n  border-color: #ddd;\n  border-width: 1px 1px 1px 0;\n  cursor: pointer;\n  z-index: 1;\n  white-space: nowrap;\n  padding: 0.7em 1em;\n}\n\n.RRT__tab:focus {\n  outline: 0;\n  background-color: #e6e6e6;\n}\n\n.RRT__accordion .RRT__tab {\n  border-left-width: 1px;\n}\n\n.RRT__tab--first {\n  border-left-width: 1px;\n}\n\n.RRT__tab--selected {\n  background: #fff;\n  border-color: #ddd #ddd #fff;\n}\n\n.RRT__tab--selected:focus {\n  background-color: #fff;\n}\n\n.RRT__tab--disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.RRT__tab:focus {\n  z-index: 2;\n}\n\n.RRT__tab--selected .RRT__removable {\n  position: relative;\n}\n\n.RRT__tab--selected .RRT__removable-text {\n  margin-right: 10px;\n}\n\n.RRT__tab--selected .RRT__removable-icon {\n  position: absolute;\n  font-size: 18px;\n  right: 0.5em;\n  top: 0.2em;\n}\n\n/****************************/\n/********* panel styles *****/\n/****************************/\n.RRT__panel {\n  margin-top: -1px;\n  padding: 1em;\n  border: 1px solid #ddd;\n}\n\n.RRT__panel--hidden {\n  display: none;\n}\n\n.RRT__accordion .RRT__panel {\n  margin-top: 0;\n}\n\n/****************************/\n/******* showmore control ***/\n/****************************/\n.RRT__showmore {\n  background: #eee;\n  border: 1px solid #ddd;\n  cursor: pointer;\n  z-index: 1;\n  white-space: nowrap;\n  margin-left: -1px;\n  position: relative;\n}\n\n.RRT__showmore--selected {\n  background: white;\n  border-bottom: none;\n}\n\n.RRT__showmore-label {\n  padding: 0.7em 1em;\n  position: relative;\n  bottom: -1px;\n  z-index: 1;\n}\n\n.RRT__showmore-label--selected {\n  background-color: #eee;\n}\n\n.RRT__showmore-list {\n  position: absolute;\n  right: -1px;\n  top: 100%;\n  display: none;\n}\n\n.RRT__showmore-list--opened {\n  display: block;\n}\n\n/****************************/\n/********** inkbar **********/\n/****************************/\n.RRT__inkbar-wrapper {\n  width: 100%;\n}\n\n.RRT__inkbar {\n  position: relative;\n  bottom: 0;\n  height: 2px;\n  margin-top: -2px;\n  background-color: deepskyblue;\n  transition: left 800ms cubic-bezier(0.23, 1, 0.32, 1);\n  z-index: 2;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
